import React, { useEffect } from 'react'
import { Link, Route, Routes } from 'react-router-dom'
import Home from '../pages/Home/Home'
import Overview from '../pages/Overview/Overview'
import LeadersMessage from '../pages/LeadersMessage/LeadersMessage'
import Departments from '../pages/Departments/Departments'
import FAQ from '../pages/FAQ/FAQ'
import Careers from '../pages/Careers/Careers'
import AdmissionPage from '../pages/AdmissionPage/AdmissionPage'
import AdmissionToken from '../pages/AdmissionToken/AdmissionToken'
import AdmissionForm from '../pages/AdmissionForm/AdmissionForm'
import Medicals from '../pages/Medicals/Medicals'
import PreSchool from '../pages/PreSchool/PreSchool'
import ElementarySchool from '../pages/ElementarySchool/ElementarySchool'
import LowerSecondary from '../pages/LowerSecondary/LowerSecondary'
import NewsPage from '../pages/NewsPage/NewsPage'
import ContactPage from '../pages/ContactPage/ContactPage'
import Calendar from '../pages/Calendar/Calendar'
import LoginPage from '../pages/PortalPages/LoginPage/LoginPage'
import NewsItem from '../components/NewsItem/NewsItem'
import StaffLife from '../pages/StaffLife/StaffLife'
import StudentLife from '../pages/StudentLife/StudentLife'
import ClubsAndTeams from '../pages/ClubsAndTeams/ClubsAndTeams'
import ExtraCurricular from '../pages/ExtraCurricular/ExtraCurricular'
import SignatureEvents from '../pages/SignatureEvents/SignatureEvents'
import NotFound from '../pages/NotFound/NotFound'
import Navbar from '../components/Navbar/Navbar'
import TopBar from '../components/TopBar/TopBar'
import { useLocation } from 'react-router-dom'
import { BsWhatsapp } from 'react-icons/bs'

const WebsiteRoutes = () => {

  const location = useLocation();
  useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
  return (
    <div>
        <TopBar />
        <Navbar />
        <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/about/overview" element={<Overview />} />
            <Route path="/about/message-from-head" element={<LeadersMessage />} />
            <Route path="/about/departments" element={<Departments />} />
            <Route path="/about/faq" element={<FAQ />} />
            <Route path="/about/careers" element={<Careers />} />
            <Route path="/admission" element={<AdmissionPage />} />
            <Route path="/admission/apply" element={<AdmissionToken />} />
            <Route path="/admission/:token/application" element={<AdmissionForm />} />
            <Route path="/admission/:token/medicals" element={<Medicals />} />
            <Route path="/schools/preschool" element={<PreSchool />} />
            <Route path="/schools/elementary" element={<ElementarySchool />} />
            <Route path="/schools/lower-secondary" element={<LowerSecondary />} />
            <Route path="/news-events/news" element={<NewsPage />} />
            <Route path="/news-events/news/:slug" element={<NewsItem />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/news-events/calendar" element={<Calendar />} />
            <Route path="/schools/student-life" element={<StudentLife />} />
            <Route path="/schools/clubs-teams" element={<ClubsAndTeams />} />
            <Route path="/schools/extra-curricular" element={<ExtraCurricular />} />
            <Route path="/schools/signature-events" element={<SignatureEvents />} />
            <Route path="/anell-360/staff-life" element={<StaffLife />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
        <Link
          to="https://wa.me/2330504828824?text="
          target="_blank"
          className="fixed bottom-8 right-8 bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 z-50 animate-bounce"
          aria-label="Contact on WhatsApp"
        >
          <BsWhatsapp size={28} />
        </Link>
    </div>
  )
}

export default WebsiteRoutes